import { defineComponent } from 'vue';
import { EmailEditor } from '../vue-email-editor';
import sample from '../data/sample.json';
export default defineComponent({
    name: 'exampleView',
    components: {
        EmailEditor
    },
    data() {
        return {
            emailEditor: null,
            options: {
                appearance: {
                    theme: 'modern_light',
                },
                version: 'latest',
            }
        };
    },
    mounted() {
        // Assign the ref with a type assertion
        this.emailEditor = this.$refs.emailEditor;
    },
    methods: {
        // called when the editor is created
        editorLoaded() {
            this?.emailEditor?.editor?.loadDesign(sample);
        },
        // called when the editor has finished loading
        editorReady() {
            console.log('editorReady');
        },
        saveDesign() {
            this.emailEditor?.editor?.saveDesign((design) => {
                console.log('saveDesign', design);
            });
        },
        exportHtml() {
            this?.emailEditor?.editor?.exportHtml((data) => {
                console.log('exportHtml', data);
            });
        }
    }
});
